export var searchTypes = [
    {
        id: 'book-section',
        label: 'Book Section'
    },
    {
        id: 'monograph',
        label: 'Monograph'
    },
    {
        id: 'report',
        label: 'Report'
    },
    {
        id: 'peer-review',
        label: 'Peer Review'
    },
    {
        id: 'book-track',
        label: 'Book Track'
    },
    {
        id: 'journal-article',
        label: 'Journal Article'
    },
    {
        id: 'book-part',
        label: 'Part'
    },
    {
        id: 'other',
        label: 'Other'
    },
    {
        id: 'book',
        label: 'Book'
    },
    {
        id: 'journal-volume',
        label: 'Journal Volume'
    },
    {
        id: 'book-set',
        label: 'Book Set'
    },
    {
        id: 'reference-entry',
        label: 'Reference Entry'
    },
    {
        id: 'proceedings-article',
        label: 'Proceedings Article'
    },
    {
        id: 'journal',
        label: 'Journal'
    },
    {
        id: 'component',
        label: 'Component'
    },
    {
        id: 'book-chapter',
        label: 'Book Chapter'
    },
    {
        id: 'proceedings-series',
        label: 'Proceedings Series'
    },
    {
        id: 'report-series',
        label: 'Report Series'
    },
    {
        id: 'proceedings',
        label: 'Proceedings'
    },
    {
        id: 'standard',
        label: 'Standard'
    },
    {
        id: 'reference-book',
        label: 'Reference Book'
    },
    {
        id: 'posted-content',
        label: 'Posted Content'
    },
    {
        id: 'journal-issue',
        label: 'Journal Issue'
    },
    {
        id: 'dissertation',
        label: 'Dissertation'
    },
    {
        id: 'dataset',
        label: 'Dataset'
    },
    {
        id: 'book-series',
        label: 'Book Series'
    },
    {
        id: 'edited-book',
        label: 'Edited Book'
    },
    {
        id: 'standard-series',
        label: 'Standard Series'
    }
];
export var getSearchTypeLabel = function (id) {
    var findType = searchTypes.find(function (t) { return t.id === id; });
    if (findType) {
        return findType.label;
    }
    return '';
};
